import getFactorClient from "./getFactorClient";

const EMPTY = [];

const getFreezeExemptContractTypes = state => {
  const client = getFactorClient(state);
  return (client && client.freeze_exempt_contract_types) || EMPTY;
};

export default getFreezeExemptContractTypes;
